<template>
<div class="uploadDiv">
    <el-upload
                v-if="canEdit"
               :action="$root.uploadUrl"
               :show-file-list="false"
               :before-upload="beforeAvatarUpload"
               :on-progress="fileListHandleProgress"
               :on-success="fileListHandleSuccess"
               :on-error="fileListHandleError"
               :multiple="noMany ? false : true"
                :style="this.dir=='hor'?'display: inline':''">
        <el-button v-if="isShowIcon == 1" size="small" type="primary"
                   :loading="fileListLoading"
                   :disabled="fileListDisabled">
            {{(fileListLoading)?'上传中...':'点击上传'}}
        </el-button>
        <el-button v-else size="small" type="default"
                   :loading="fileListLoading"
                   :disabled="fileListDisabled">
            <i class="el-icon-upload2"></i>
            {{(fileListLoading)?'上传中...':'上传'}}
        </el-button>
    </el-upload>
    <div v-if="this.dir == 'hor'" style="display: inline">
        <div v-if="fileList && fileList.length" style="display: inline">
            <span><i class="el-icon-document file-list file-item"></i>{{fileList[0].attachName}}</span>
        </div>
        <div v-if="fileList && fileList.length" class="file-button" style="display: inline">
            <span @click="fileListHandleRemove(0)"><i class="el-icon-close"></i></span>
        </div>
    </div>
    <div class="file-list" v-else-if="!isShowList">
        <div v-if="fileList && fileList.length">
            <div v-for="(file,index) in fileList" :key="index" class="file-item clearfix">
                <div class="file-name">
                    <span @click="fileListHandleDownload(file)" title="点击下载" style="text-decoration: underline;cursor: pointer;color:#0091FF"><i class="el-icon-document"></i>{{file.attachName}}</span>
                </div>
                <div class="file-button">
                    <el-button type="text" v-show="canEdit" size="small" @click="fileListHandleRemove(index)" class="sc"><i class="el-icon-close"></i></el-button>
                    <el-button type="text" size="mini"  @click="preview(index,file)" class="yl">预览</el-button>
                </div>
            </div>
        </div>
        <div v-else-if="!canEdit">
            无
        </div>
    </div>
</div>
</template>

<script type="text/babel">
    import Vue from 'vue'
    import util from '@/util/'
    export default Vue.component('page-upload', {
        data () {
            return {
                fileList: [],
                fileType: this.attachmentType,
                fileListLoading: false,
                fileListDisabled: false,//上传按钮是否禁用
                canEdit: this.editFlag,//是否可下载
                limit: this.limitType,//限制大小
                isShowIcon: this.isIconTable,//是否显示带图标按钮，及把上传文件列表按照table表格来显示；2,代表显示，1，代表不显示图标，普通上传。
                isShowList: this.notViewList || '',//传值true 代表不显示文件列表，自定义展现列表，不传代表用默认的列表
                noMany: this.notMany || '',//true,不支持上传多个文件，false，支持上传多个文件
                disAble: this.disable || '',//禁用,
                isSaveNow:this.saveNow || false,
            }
        },
        props: ['attachmentType','files','editFlag','limitType','isIconTable','notViewList','notMany','disable','dir'],
//        limitType,表示上传文件的大小限制类型 1：代表普通附件，限制50M，2: 代表招标附件，限制300M；
        watch: {
            files(val){
                this.fileList = this.files;
            }
        },
        created(){
            if(this.disAble){
                this.fileListDisabled = true;
            }
        },
        methods: {
            // 预览
            preview(index, file) {
                console.log(file)
                window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.sessionStorage.getItem('token')+'&attachmentPath='+file.attachPath+'&attachmentName='+encodeURIComponent(file.attachName))
                // this.fileList = file
                // if(this.fileList){
                //     this.fileList.forEach((imgObj)=>{
                //         window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
                //         // imgObj['imgUrl'] = util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName)
                //     })
                // }
            },
            beforeAvatarUpload(file) {
                const isLt50M = file.size / 1024 / 1024 < 50;
                const isLt500M = file.size / 1024 / 1024 < 500;
                if(this.limit == 1){
                    if (!isLt50M) {
                        this.$message.error('上传附件大小不能超过 50MB!');
                        return isLt50M;
                    }
                } else if(this.limit == 2){
                    if (!isLt500M) {
                        this.$message.error('上传附件大小不能超过 500MB!');
                        return isLt500M;
                    }
                }
            },
            fileListHandleProgress(){
                this.fileListLoading = true;
                this.fileListDisabled = true;
            },
            fileListHandleSuccess(response){
                let that = this;
                that.fileListLoading = false;
                that.fileListDisabled = false;
                if(response.code == 1){
                    for(let i=0; i< response.data.length; i++){
                        let obj = response.data[i];
                        obj['attachmentType'] = that.fileType;
                        if(that.noMany){
                           that.fileList = [];
                            that.fileList.push(obj);
                        } else {
                            that.fileList.push(obj);
                        }
                    }
                   console.log('上传',that.fileList)
                //    修改之后传值
                //    that.$emit('finishUpload',that.fileList);
                   //    修改之前传值
                    that.$emit('finishUpload',{fileList: that.fileList});
                    that.$message.success('上传成功');
                }else{
                    this.$message.error('上传失败');
                }
            },
            fileListHandleError(response){
                let that = this;
//                console.log('上传失败',response);
                that.$message.error('上传失败');
                that.fileListLoading = false;
                that.fileListDisabled = false;
            },
            fileListHandleRemove(index){
//                console.log(index)
                let that = this;
                that.$confirm('确定删除该附件吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            that.fileList.splice(index,1);
                            that.$emit('finishUpload',{fileList: that.fileList});
                        }
                    }
                });
            },
            fileListHandleDownload(file){
                let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            that.$root.downloadFile({
                                attachName: file.attachName,
                                attachPath: file.attachPath
                            })
                        }
                    }
                });
            }
        },
        mounted(){
            this.fileList = this.files;
        }
    })

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '../../assets/_var.scss';
    .file-list{
        width:100%;
        display: flex;
    }
    .file-list .file-item{
        // overflow: hidden;
        // width: 350px;
        width:100%;
        display: flex;
    }
    .file-list .file-name{
        width:100%;
        // float: left;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
    }
    .file-list .file-button{
        // border: 1px solid red;
        display: flex;
        .sc{
            flex: 1;
        }
        .yl{
            flex: 1;
        }
        // width:50%;
        // float: left;
        // margin-left: 20px;
        .el-icon-close{
            font-size: 14px;
            font-weight: bold;
            color: #DD4A68;
        }
    }

    .uploadDiv /deep/ {
        .el-button--small {
            padding: 7px 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/MyUpload.vue